import '../../css/FormTemplate.css'
import { IFormInternalDivFileTemplate } from "../../interfaces/interface";
import FormErrorDivTemplate from './FormErrorDivTemplate';
import FormTemplateLabel from './FormTemplateLabel';

const FormInternalDivFileTemplate = (props:IFormInternalDivFileTemplate) => {

    return (
        <div className="form-template-internal-div">
            <FormTemplateLabel id={"file-name-input"} label={props.label} dataToolTip={props.dataToolTip}/>
            <div className='form-template-input-div-icon' >
                <input 
                type="file"
                accept={props.accept}
                id={props.id} 
                className="file-Upload-input" 
                onChange={props.onChange}
                disabled={props.disabled}
                onClick={props.onClick}
                />
                <input 
                    className="form-template-input" 
                    id='file-name-input'
                    value={props.value}
                    placeholder="please choose file..."
                    disabled
                />
                <label htmlFor={props.id}  className="file-Upload-label" >
                    <img className="file-Upload-img" src="/icons/file-upload.png" alt="upload-file" />  
                </label>
            </div> 
            <FormErrorDivTemplate displayMessage={props.displayMessage} message={props.message}/>
    </div>
    );
};


export default FormInternalDivFileTemplate;